export default "__VITE_ASSET__CKKVhi0x__"